import EmailVerificationRequest from "./EmailVerificationRequest";

export default EmailVerificationRequest;
